import { render, staticRenderFns } from "./shopDetailInfo.vue?vue&type=template&id=8137833a&scoped=true"
import script from "./shopDetailInfo.vue?vue&type=script&lang=js"
export * from "./shopDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./shopDetailInfo.vue?vue&type=style&index=0&id=8137833a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8137833a",
  null
  
)

export default component.exports